import React from 'react';

const LoginWarningPage = () => {
  return (
    <div>
      <div className="ita-warning alert alert-primary">
        You are about to access a U.S. Government computer/information system. Access to
        this system is restricted to authorized users only. Unauthorized access, use, or
        modification of this computer system or of the data contained herein, or in
        transit to/from this system, may constitute a violation of <a title="18 USC 1030: Fraud and related activity in connection with computers" href="https://www.osha.gov/injuryreporting/18usc1030"
        target = "_blank" > Title 18,
        United States Code,
        Section 1030</a> and other federal or state criminal andcivil laws. These systems and equipment
        are subject to monitoring to ensure proper performance of applicable security
        features or procedures. Such monitoring may result in the acquisition, recording
        and analysis of all data being communicated, transmitted, processed or stored in
        this system by a user.
        <br/>
        <br/>
        If monitoring reveals possible misuse or criminal activity, notice of such may
        be provided to supervisory personnel and law enforcement officials as evidence.
        <br/>
        <br/>
        Anyone who accesses a Federal computer system without authorization or exceeds
        their access authority, and by any means of such conduct obtains, alters,
        damages, destroys, or discloses information, or prevents authorized use of
        information on the computer, may be subject to fine or imprisonment, or both.
        <br/>
        <br/>
        Your use of this system indicates understanding that you are personally
        responsible for your use and any misuse of your access including your system
        account and password. Use further indicates understanding that by accessing a
        U.S. Government information system that you must comply with the prescribed
        policies and procedures. Lastly, your use shall serve as acknowledgement of
        receipt of, your understanding of your responsibilities, and your willingness to
        comply with the rules of behavior for this system.
      </div>
    </div>
  );
};

export default LoginWarningPage;



/** WEBPACK FOOTER **
 ** ./src/components/authentication/login/LoginWarningPage.js
 **/